import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";
const AptevoChargebacks = () => {
	const fileName = "Aptevo Chargebacks Source ";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [aptevoChargeBacks, setAptevoChargeBacks] = useState([]);
	const [loading, setLoading] = useState(false);
	// const [showToaster, setShowToaster] = useState(false);
	// let Message;
	const [hasError, setHasError] = useState(false);
	// excel Headers
	const excelColumns = [
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
		},
		{
			Header: "Distributor HIN #",
			accessor: "DistributorHIN",
			filter: "DistributorHIN",
			sortType: "basic",
		},
		{
			Header: "Debit Memo/Document #",
			accessor: "DebitMemo",
			filter: "DebitMemo",
			sortType: "basic",
		},
		{
			Header: "Total line count",
			accessor: "TotalLineCount",
			filter: "TotalLineCount",
			sortType: "basic",
		},
		{
			Header: "Total Amount Requested",
			accessor: "TotalAmountRequested",
			filter: "TotalAmountRequested",
			sortType: "basic",
		},
		{
			Header: "340B ID/ HIN",
			accessor: "HIN",
			filter: "HIN",
			sortType: "basic",
		},
		{
			Header: "Invoice Date",
			accessor: "InvoiceDate",
			filter: "InvoiceDate",
			sortType: "basic",
			width: 110,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Invoice #",
			accessor: "InvoiceID",
			filter: "InvoiceID",
			sortType: "basic",
			width: 90,
		},
		{
			Header: "Product NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			width: 130,
		},
		{
			Header: "Product Description",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
		},
		{
			Header: "Contract ID #",
			accessor: "ContractID",
			filter: "ContractID",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Qty",
			accessor: "Quantity",
			filter: "Quantity",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Orig WAC Price Per Pkg",
			accessor: "OrigWACPricePerPkg",
			filter: "OrigWACPricePerPkg",
			sortType: "basic",
		},
		{
			Header: "Contract Price Per Pkg",
			accessor: "ContractPricePerPkg",
			filter: "ContractPricePerPkg",
			sortType: "basic",
		},
		{
			Header: "Chargeback Amount (Ext Total)",
			accessor: "ChargebackAmount",
			filter: "ChargebackAmount",
			sortType: "basic",
		},
		{
			Header: "Total Amount Claimed",
			accessor: "TotalAmountClaimed",
			filter: "TotalAmountClaimed",
			sortType: "TotalAmountClaimed",
		},
	];

	useEffect(() => {
		getAptevoChargeBacks();
	}, []);
	async function getAptevoChargeBacks() {
		setLoading(true);
		// ${outbounddata.FileProcessID}  ${outbounddata.ServiceTaskID}
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const aptevoChargeBacks = data.data;
				if (aptevoChargeBacks.length > 0) {
					let ind = 1;
					aptevoChargeBacks.map((res) => {
						res.InvoiceDate = moment(res.InvoiceDate).format("MM/DD/YYYY");
						res.ind = ind++;
						// res.ContractpriceperIUOREUORGram = res.ContractpriceperIUOREUORGram == null? "0.00" : (res.ContractpriceperIUOREUORGram*1).toFixed(2);
						// res.DACperIUOREUORGram = res.DACperIUOREUORGram == null? "0.00" : (res.DACperIUOREUORGram*1).toFixed(2);
						// res.ChargebackAmount ="$" + res.ChargebackAmount;
					});
				}
				setAptevoChargeBacks(aptevoChargeBacks);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				// Message = e.response.data.Message;
				// setShowToaster(true);
				setHasError(true);
			});
	}
	const EditRecords = () => {
		// setShowConfirm(true);
		// setGridShow(true);
		localStorage.setItem("chargeback", JSON.stringify(aptevoChargeBacks));
		history.push("/ChargebackAddEdit");
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">Aptevo Chargebacks Source Map</h2>
				{loading ? <Loader /> : null}
				<div>
					{aptevoChargeBacks.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EditRecords()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EditRecords()}>
								Edit Records
							</Button>
						))}
					{/* <Button type="submit" onClick={() =>EditRecords()}>EditRecords</Button> */}
					<Button
						type="submit"
						className="ml-2"
						onClick={() => getExcel(excelColumns, aptevoChargeBacks, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			{/* Toaster */}
			{/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>
										Error occurred. Unable to load Aptevo Chargebacks Source.
									</p>
								) : (
									<Fragment>
										{aptevoChargeBacks.length > 0 ? (
											<ReactTable
												columns={excelColumns}
												data={aptevoChargeBacks}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default AptevoChargebacks;
